import AppHeader from "@/components/AppHeader";
import dayjs from "dayjs";

export default {
  name: "master-site-detail",
  components: {
    AppHeader
  },
  created() {
    this.getSite();
  },
  data() {
    return {
      isGetSiteEnd: false,
      siteId: this.$route.params.site_id,
      site: []
    };
  },
  methods: {
    async getSite() {
      this.isGetSiteEnd = false;
      let data = {
        site_id: this.siteId
      };
      let res = await this.$store
        .dispatch("GET_SITE_DETAIL", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.site = res.site;
      this.isGetSiteEnd = true;
    },
    dateFormat(date) {
      if (!date) {
        return "";
      }
      return dayjs(date).format("YYYY年MM月DD日");
    },
    goMasterSiteEdit() {
      this.$router.push({ path: `/master_site/${this.siteId}/edit` });
    }
  }
};
